export const text = {
  delete: "Delete this product?",
  confirm: "Are you sure you want to delete this product?",
  yes: "Yes",
  no: "No",
};
